// src/routes/AdmissionsRouteGuard.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { hasPermission } from "../utils/permissions";
import { useAppSelector } from "../hooks/useAppSelector";

export default function AdmissionsRouteGuard({
  children,
}: {
  children: JSX.Element;
}) {
  // Prefer the JWT-derived user (should have .permissions), fallback to doctorInfo
  const authUser = useAppSelector((s) => (s as any).auth?.user);
  const doctorInfo = useAppSelector((s) => (s as any).auth?.doctorInfo);
  const permsSource = authUser ?? doctorInfo;

  if (!hasPermission(permsSource, "canAdmitPatient")) {
    return <Navigate to="/doctor" replace />;
  }

  return children;
}
